export default __webpack_public_path__ + "static/media/logoIpsis.15cd50d6.png";